import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

const stats = [
  { value: "10万+", label: "电影资源" },
  { value: "5000万+", label: "累计用户" },
  { value: "99.9%", label: "播放成功率" },
  { value: "24h", label: "内容更新" },
];

const testimonials = [
  {
    name: "张先生",
    role: "资深影迷",
    content: "555电影网的画质真的没得说，高清流畅不缓冲，而且片源更新速度非常快。现在每天下班回家第一件事就是打开555电影网看看有什么新片。",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20Chinese%20man%20in%20his%2030s%2C%20warm%20lighting%2C%20friendly%20expression%2C%20simple%20cream%20background%2C%20portrait%20photography&width=100&height=100&seq=avatar-zhang&orientation=squarish",
  },
  {
    name: "李女士",
    role: "电影爱好者",
    content: "作为电影爱好者，我用过很多平台，555电影网是目前体验最好的。分类清晰，搜索方便，而且完全免费，真心推荐给所有喜欢看电影的朋友。",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20Chinese%20woman%20in%20her%20late%2020s%2C%20warm%20lighting%2C%20gentle%20smile%2C%20simple%20cream%20background%2C%20portrait%20photography&width=100&height=100&seq=avatar-li&orientation=squarish",
  },
  {
    name: "王同学",
    role: "大学生",
    content: "宿舍网速不太稳定，但是555电影网的加载速度真的让我惊艳。几乎不用等待就能直接观看，而且高清画质在大屏幕上看起来特别爽。",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20Chinese%20college%20student%20male%2C%20warm%20lighting%2C%20bright%20smile%2C%20simple%20cream%20background%2C%20portrait%20photography&width=100&height=100&seq=avatar-wang&orientation=squarish",
  },
];

export default function About() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-background-50">
      <header>
        <Navbar />
      </header>

      <main className="pt-20">
        {/* Breadcrumb */}
        <div className="px-4 md:px-6 py-6">
          <div className="max-w-7xl mx-auto">
            <nav className="flex items-center gap-2 text-sm text-foreground-500 mb-6" aria-label="面包屑导航">
              <Link to="/" className="hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">
                首页
              </Link>
              <i className="ri-arrow-right-s-line text-xs"></i>
              <span className="text-foreground-700 font-medium">关于我们</span>
            </nav>
          </div>
        </div>

        {/* Brand Intro */}
        <section className="px-4 md:px-6 py-10 md:py-16 bg-background-50">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-6">
              关于555电影网
            </h1>
            <p className="text-base text-foreground-600 leading-relaxed max-w-3xl mx-auto">
              555电影网成立于2020年，致力于为广大电影爱好者提供<strong>免费高清在线观看</strong>服务。我们拥有海量电影资源，涵盖动作、喜剧、科幻、悬疑、动画等多种类型，覆盖最新院线大片与经典老片。凭借先进的视频加速技术，我们实现了<strong>全集电影不缓冲秒播放</strong>的极致体验，让每一位用户都能享受<strong>流畅观影</strong>的乐趣。
            </p>
          </div>
        </section>

        {/* Stats */}
        <section className="px-4 md:px-6 py-12 md:py-16 bg-background-100">
          <div className="max-w-5xl mx-auto">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
              {stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-3xl md:text-4xl font-heading font-bold text-primary-500 mb-2">
                    {stat.value}
                  </div>
                  <div className="text-sm text-foreground-500">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Testimonials */}
        <section className="px-4 md:px-6 py-14 md:py-20 bg-background-50">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-10">
              用户口碑
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {testimonials.map((t) => (
                <div
                  key={t.name}
                  className="p-6 rounded-xl bg-background-100"
                >
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
                      <img
                        src={t.avatar}
                        alt={t.name}
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-900">{t.name}</p>
                      <p className="text-xs text-foreground-500">{t.role}</p>
                    </div>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    "{t.content}"
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Contact */}
        <section className="px-4 md:px-6 py-14 md:py-20 bg-background-100">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-10">
              联系我们
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="text-center p-6 rounded-xl bg-background-50">
                <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center">
                  <i className="ri-mail-line text-2xl text-primary-500"></i>
                </div>
                <h3 className="text-sm font-medium text-foreground-900 mb-1">电子邮箱</h3>
                <p className="text-sm text-foreground-500">contact@555movie.com</p>
              </div>
              <div className="text-center p-6 rounded-xl bg-background-50">
                <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center">
                  <i className="ri-customer-service-2-line text-2xl text-primary-500"></i>
                </div>
                <h3 className="text-sm font-medium text-foreground-900 mb-1">客服热线</h3>
                <p className="text-sm text-foreground-500">400-555-6666</p>
              </div>
              <div className="text-center p-6 rounded-xl bg-background-50">
                <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center">
                  <i className="ri-map-pin-line text-2xl text-primary-500"></i>
                </div>
                <h3 className="text-sm font-medium text-foreground-900 mb-1">公司地址</h3>
                <p className="text-sm text-foreground-500">北京市朝阳区影视产业园</p>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="px-4 md:px-6 py-14 md:py-20 bg-background-50">
          <div className="max-w-3xl mx-auto">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-10">
              常见问题
            </h2>
            <div className="space-y-4">
              {[
                {
                  q: "555电影网的电影资源是免费的吗？",
                  a: "是的，555电影网所有电影资源均免费提供在线观看，无需付费、无需注册即可畅享高清画质。",
                },
                {
                  q: "观看电影需要下载播放器吗？",
                  a: "不需要。555电影网支持网页端直接播放，无需下载任何播放器或插件，打开网页即可观看。",
                },
                {
                  q: "为什么555电影网的播放速度这么快？",
                  a: "我们采用了先进的CDN加速技术和智能缓冲算法，确保全网用户都能获得流畅不卡顿的观影体验。",
                },
                {
                  q: "新电影多久会上线？",
                  a: "我们的内容团队24小时持续更新，院线热门电影通常在下映后1-2周内上线，部分影片甚至可以同步更新。",
                },
              ].map((faq, i) => (
                <details key={i} className="group rounded-xl bg-background-100 p-5 cursor-pointer">
                  <summary className="text-sm font-medium text-foreground-900 list-none flex items-center justify-between cursor-pointer">
                    {faq.q}
                    <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform"></i>
                  </summary>
                  <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
                    {faq.a}
                  </p>
                </details>
              ))}
            </div>
          </div>

          <script type="application/ld+json">
            {JSON.stringify({
              "@context": "https://schema.org",
              "@type": "FAQPage",
              mainEntity: [
                {
                  "@type": "Question",
                  name: "555电影网的电影资源是免费的吗？",
                  acceptedAnswer: {
                    "@type": "Answer",
                    text: "是的，555电影网所有电影资源均免费提供在线观看，无需付费、无需注册即可畅享高清画质。",
                  },
                },
                {
                  "@type": "Question",
                  name: "观看电影需要下载播放器吗？",
                  acceptedAnswer: {
                    "@type": "Answer",
                    text: "不需要。555电影网支持网页端直接播放，无需下载任何播放器或插件，打开网页即可观看。",
                  },
                },
                {
                  "@type": "Question",
                  name: "为什么555电影网的播放速度这么快？",
                  acceptedAnswer: {
                    "@type": "Answer",
                    text: "我们采用了先进的CDN加速技术和智能缓冲算法，确保全网用户都能获得流畅不卡顿的观影体验。",
                  },
                },
                {
                  "@type": "Question",
                  name: "新电影多久会上线？",
                  acceptedAnswer: {
                    "@type": "Answer",
                    text: "我们的内容团队24小时持续更新，院线热门电影通常在下映后1-2周内上线，部分影片甚至可以同步更新。",
                  },
                },
              ],
            })}
          </script>
        </section>
      </main>

      <Footer />
    </div>
  );
}